import React, { Component } from 'react';
import { SELF_CERTS } from '../../../constants';

class Certificates extends Component {
  renderCerts() {
    let certs = SELF_CERTS.map(({ title, img, url }) => {
      return (
        <div key={`cert ${title}`} className="anim_piece col-md-4">
  				<a href={url} target="_blank">
            <img src={`img/${img}`} className="img-fluid" alt={title} />
          </a>
  			</div>
      );
    });

    return certs;
  }

  render() {
    return (
      <section id="certificates" className="py-5">
        <div className="container">
          <div className="row">
            <div className="col">
      				<h2 className="anim_piece">CREDENTIALS</h2>
      			</div>
          </div>
          <div className="row">
            {this.renderCerts()}
          </div>
        </div>
      </section>
    );
  }
}

export default Certificates;
